module.exports = __webpack_public_path__ + "static/media/bosnia-flag.b27f32ca.png";